import * as VOXLib from 'voximplant-websdk';
import type { Client } from 'voximplant-websdk/Client';

import { provider } from 'providers';

import { getURI } from '../helpers/getURI';

/** Установить слушатель события авторизации по одноразовому ключу */
export function attachVOXAuthEvent(voxClient: Client, userId: string, setAuthorized: (state: boolean) => void) {
    voxClient.on(VOXLib.Events.AuthResult, async ({ code, key }: { code: number; key: string; name: string; result: boolean }) => {
        if (code === 302) {
            try {
                const { token } = await provider.getVOXToken(key);

                try {
                    return await voxClient.loginWithOneTimeKey(getURI(userId), token).then(() => {
                        setAuthorized(true);
                    });
                } catch (error) {
                    // eslint-disable-next-line @typescript-eslint/return-await
                    return Promise.reject(new Error(`loginWithOneTimeKey error ${JSON.stringify(error)}`));
                }
            } catch (error) {
                return Promise.reject(new Error(`getVOXToken error ${JSON.stringify(error)}`));
            }
        }

        return Promise.resolve();
    });
}
